/**
 * @generated SignedSource<<a274bce7ca5667b6c95751df15c26857>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReleaseStatusMenu_release$data = {
  readonly __typename: string;
  readonly canDelete: boolean;
  readonly id: string;
  readonly isVisible: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateOrCreateReleaseModal_release">;
  readonly " $fragmentType": "ReleaseStatusMenu_release";
};
export type ReleaseStatusMenu_release$key = {
  readonly " $data"?: ReleaseStatusMenu_release$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReleaseStatusMenu_release">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReleaseStatusMenu_release",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVisible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canDelete",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateOrCreateReleaseModal_release"
    }
  ],
  "type": "ReleaseInterface",
  "abstractKey": "__isReleaseInterface"
};

(node as any).hash = "5f6fe2e44744ba7c1614a4fe0016898c";

export default node;
